import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { SearchBoxes } from './SearchBoxes.js';

import { makeSearchURL } from './searchRequestUtils.js';


export const StandaloneSearchBoxes = function (props) {
    const searchURL = props.searchURL;
    const [filterCategories, setFilterCategories] = React.useState(props.filterCategories);
    const [extraFilters, setExtraFilters] = React.useState(props.extraFilters);

    function innerMakeSearchURL(params, overrideSearchURL) {
        return makeSearchURL(params, overrideSearchURL || searchURL);
    }
    function applyFilters(params) {
        location.href = makeSearchURL(params, searchURL);
    }
    function changeURL(url) {
        location.href = url;
    }

    const searchFiltersURL = '/common/searchFilters.html?APIKey=' + dcAPIKey;
    React.useEffect(() => {
        // If we didn't get filters on page load, get them with AJAX
        if (!props.filterCategories) {
            $.get(searchFiltersURL, null, (filterMap) => {
                setFilterCategories(filterMap.filterCategories);
                setExtraFilters(filterMap.extraFilters);
            }, 'json');
        }
    }, []);

    return <SearchBoxes {...props} filterCategories={filterCategories} extraFilters={extraFilters}
        callbacks={{ makeSearchURL: innerMakeSearchURL, applyFilters, changeURL }} />;
};

StandaloneSearchBoxes.propTypes = {
    searchURL: PropTypes.string.isRequired,
    baseSearchURL: PropTypes.string.isRequired,

    detectedLocation: PropTypes.object,
    filterCategories: PropTypes.array,
    extraFilters: PropTypes.array,
    projects: PropTypes.object,
    showBrowseLink: PropTypes.bool,
    placeholder: PropTypes.string,
};
